define([
  /* eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min',
  'readingiq-src/js/riq-js/riq-listener-set-previous-state-route/1.0.0/js/state-service/index'
  /* eslint-enable */
], function riqListenerSetPreviousStateRouteModule(app, aoflModules) {
  'use strict';

  var storeService = aoflModules.store;

  app.registerComponent('riqListenerSetPreviousStateRoute', {
    require: {},
    bindings: {},
    controller: 'riqListenerSetPreviousStateRouteController'
  });
  app.registerController('riqListenerSetPreviousStateRouteController', [
    '$rootScope',
    'riqListenerSetPreviousStateRouteStateService',
    function controller(
      $rootScope,
      riqListenerSetPreviousStateRouteStateService
    ) {
      storeService.addState(riqListenerSetPreviousStateRouteStateService);
      var whitelist = {
        library_en: true,
        collection_en: true,
        categories_details_en: true,
        categories_en: true,
        search_en: true,
        my_shelf_en: true,
        my_account_en: true,
        redeem_code_en: true
      };
      var blacklist = {
        book_player_en: true,
        comprehension_check_en: true,
        onboarding_en: true
      };

      $rootScope.$on('$stateChangeSuccess', function onStateChangeSuccess(
        event,
        toState,
        toStateParams,
        fromState,
        fromStateParams
      ) {
        var state = storeService.getState();
        if (
          (whitelist[fromState.name] || state.profile.isGroupOwner) &&
          !blacklist[fromState.name]
        ) {
          var previousState = {
            name: fromState.name,
            params: fromStateParams
          };
          localStorage.setItem(
            'riqListenerSetPreviousStateRouteName',
            previousState.name
          );
          localStorage.setItem(
            'riqListenerSetPreviousStateRouteParams',
            angular.toJson(previousState.params)
          );
          storeService.commit([
            {
              stateAlias: 'riqListenerSetPreviousStateRoute',
              mutationId: 'setPreviousState',
              payload: previousState
            }
          ]);
        }
      });
    }
  ]);
});
